// The actual credential (the WorkOS access token) now lives in an httpOnly
// cookie set by the API — this module never sees it and never could (that
// was the whole point of the migration, see GearLocker-Context.md Section 15).
//
// This is just a lightweight in-memory flag for synchronous UI routing
// (ProtectedRoute) between the async session-check calls in AuthContext. It
// is NOT a security boundary — losing it (e.g. on page reload) only means
// AuthContext's mount-time checkSession() call re-establishes it by asking
// the API, which is exactly what fixes the old "bounced back to login on
// every reload" bug: that check now succeeds because the browser still has
// the httpOnly cookie, regardless of what this in-memory flag says.

let _authenticated = false

export const auth = {
  markAuthenticated() {
    _authenticated = true
  },

  markLoggedOut() {
    _authenticated = false
  },

  isAuthenticated(): boolean {
    return _authenticated
  },
}
